const activity = {
  activity: "Aktivitas", // translated 
  activities: "Kegiatan", // translated 
  dates: "tanggal", // translated 
  location: "Lokasi", // translated 
  languages: "Bahasa", // translated 
  categories: "Kategori", // translated 
  ticketOption: "Opsi Tiket", // translated 
  numberOfRatings: "Jumlah peringkat", // translated 
  meetingPointInfo: "Informasi titik pertemuan", // translated 
  meetingPoint: "Titik temu", // translated 
  meetingPoints: "Titik pertemuan", // translated 
  providedBy: "Disediakan oleh", // translated 
  expirationDate: "Tanggal habis tempo", // translated 
  groupSize: "Ukuran kelompok", // translated 
  features: "Fitur", // translated 
  basedOn: "Berdasarkan", // translated 
  reviewsFromVerCustomers: "ulasan dari pelanggan terverifikasi", // translated 
  excellent: "bagus sekali", // translated 
  great: "Besar", // translated 
  average: "rata-rata", // translated 
  poor: "miskin", // translated 
  bad: "buruk", // translated 
  onlyBookedCustomersTooltip:
    "Hanya pelanggan yang memesan aktivitas ini yang dapat memberikan ulasan", // translated 
  noReviewsYet: "Saat ini, belum ada ulasan untuk aktivitas ini.", // translated 
  backToActivitiesList: "Kembali ke daftar aktivitas", // translated 
  getPrices: "mendapatkan harga", // translated 
  availabilityAndPrices: "Ketersediaan dan harga", // translated 
  ticketOptions: "Pilihan tiket", // translated 
  ticketInfo: "Informasi tiket", // translated 
  selectYourTickets: "Pilih tiket Anda", // translated 
  product: "Produk", // translated 
  total: "Total", // translated 
  slot: "celah", // translated 
  language: "Bahasa", // translated 
  tickets: "Tiket", // translated 
  ticketsFor: "Tiket Untuk", // translated 
  previousStep: "Langkah sebelumnya", // translated 
  onlyAvailableInEnglish: "Hanya tersedia dalam bahasa Inggris", // translated 
  guest: "Tamu", // translated 
  leadGuest: "Tamu utama", // translated 
  adult: "Dewasa", // translated 
  child: "Anak", // translated 
  pleaseSelectAdult: "Silakan pilih setidaknya satu orang dewasa", // translated 
  notAvailableActivity: "Produk ini tidak tersedia", // translated 
  required: "Diperlukan", // translated 
  pickupPoint: "Titik Penjemputan", // translated 
  pickupPoints: "Titik Penjemputan", // translated 
  ticketType: "Jenis Tiket", // translated 
  anonymous: "Anonim", // translated 
  printedVoucher: "Voucher Cetak Diterima", // translated 
  mobileVoucher: "Voucher Seluler Diterima", // translated 
  mixedVoucher: "Voucher seluler atau cetak Diterima", // translated 
  safetyMeasures: "Langkah-langkah keamanan diterapkan", // translated 
  doThisBecause: "Lakukan Ini Karena", // translated 
  safetyInfo: "Informasi Keamanan", // translated 
  reviewsHighestFirst: "Jumlah Ulasan (tertinggi pertama)", // translated 
  bookingFee: "Biaya pemesanan", // translated 
  startDate: "Mulai tanggal", // translated 
  endDate: "Tanggal Berakhir", // translated 
  cancellationDeadlineAndFees: "Batas Waktu dan Biaya Pembatalan", // translated 
  resetTickets: "Atur Ulang Tiket", // translated 
  instantConfirmation: "Konfirmasi Instan", // translated 
  clickResetBtn: "Klik tombol reset untuk memulai kembali pilihan Anda", // translated 
  whatToRemember: "Apa yang perlu diingat", // translated 
};


export default activity;
